module.exports = __webpack_public_path__ + "static/media/jio_icon.59a02cb4.png";